import axios from 'axios'
import { Message } from 'element-ui'
const baseURL = process.env.BASE_URL
// const baseURL = 'http://127.0.0.1:9001/zhqc-sso';
const service = axios.create({
  baseURL: baseURL,
  timeout: 30000 // 请求超时时间
})
/** **** request拦截器==>对请求参数做处理 ******/
service.interceptors.request.use(config => {
  //
  config.headers['Content-Type'] = 'application/json'
  if (config.url != '/fmUser/login') {
    const token1 = localStorage.getItem('token')
    config.headers.Authorization = token1
  } else {
    config.headers.Authorization = null
  }
  return config
}, error => { // 请求错误处理
  //
  Message({
    //  饿了么的消息弹窗组件,类似toast
    showClose: true,
    message: response.data.msg,
    type: error
  })
  Promise.reject(error)
})

/** **** respone拦截器==>对响应做处理 ******/
service.interceptors.response.use(
  response => { // 成功请求到数据
    if (response.data.code === 200) {
    } else {
      if (response.data.msg) {
        Message({
          //  饿了么的消息弹窗组件,类似toast
          showClose: true,
          message: response.data.msg,
          type: 'error'
        })
      }
    }
    return response.data
  },
  error => { // 响应错误处理
    //
    if (error.response === undefined) {
      Message({
        //  饿了么的消息弹窗组件,类似toast
        showClose: true,
        message: '网络超时，请稍后再试',
        type: 'error'
      })
      const resp = {}
      resp.code = error.response.status
      return resp
    }
    if (error.response.status === 401) { // 登录失效重新登录
      return refreshToken({ platForm: 'Web', refreshToken: localStorage.getItem('refresh') }).then((res) => {
        if (res.code === 200) {
          localStorage.setItem('token', res.obj)
          const config = error.config
          config.isRetryRequest = true
          config.headers.Authorization = res.obj
          return axios(config)
        } else {
          toLogin()
        }
      }).catch(e => {
        toLogin()
      })
    } else {
      Message({
        showClose: true,
        message: '网络超时，请稍后再试',
        type: 'error'
      })
      const resp = {}
      resp.code = error.response.status
      return resp
    }
  }
)
const toLogin = function () {
  localStorage.clear()
  sessionStorage.clear()
  window.location.href = '/login'
}
const refreshService = axios.create({
  baseURL: baseURL,
  timeout: 5000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
})
const refreshToken = params => {
  return refreshService.post('/fmUser/refresh', params).then(res => res.data)
}
export default service



// WEBPACK FOOTER //
// ./src/utils/server.js